import { Box } from "@chakra-ui/react";

export default function OffsetTop() {
  return <Box pt={["100px", "100px", "100px", "320px"]} />;
}
